<template>
  <div class="button-container">
    <button v-if="showPendingButton"
            @click.prevent="buttonAction('Pending')"
            class="pending-button">
      <i class="far fa-redo pending-button_icon"/>
    </button>
    <button v-if="showDeclineButton"
            @click.prevent="buttonAction('Declined')"
            class="decline-button">
      <i class="far fa-times decline-icon" />
    </button>
    <button v-if="showApproveButton"
            @click.prevent="buttonAction('Approved')"
            class="approve-button">
      <i class="far fa-check approve-icon" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    showPendingButton: {
      default: false,
      type: Boolean
    },
    showDeclineButton: {
      default: true,
      type: Boolean
    },
    showApproveButton: {
      default: true,
      type: Boolean
    }
  },
  methods: {
    buttonAction: function (status) {
      this.$emit('updateStatus', status)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
.button-container {
  display: flex;
  justify-content: space-around;
  button {
    border: none;
    background-color: transparent;
    z-index: 1;
    i {
      font-size: 2rem;
      z-index: 1;
      cursor: pointer;
      transition: font-size 0.2s;
      transition: color 0.5s;
    }
  }
  .pending-button {
    color: #6F8FAF;
    margin-left: 1rem;
    &_icon {
       font-size: 1.5rem;
     }
    &:hover{
     color: #0096FF;
   }
  }
  .approve-button {
    color: #AFE1AF;
    margin-left: 1rem;
    margin-left: 1rem;
    &:hover {
      color: #008000;
    }
  }
  .decline-button {
    color: #FAA0A0;
    margin-right: 1rem;
    margin-left: 1rem;
    &:hover{
       color: #CD5C5C;
    }
  }
}
</style>
